import {HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpRequest} from '@angular/common/http';
import {catchError, Observable, throwError} from 'rxjs';
import {inject} from '@angular/core';
import {ENDPOINT_DOMAIN} from '@shared/consts/auth';
import {HttpApiError} from './http-api.error';

export const httpApiErrorInterceptor = (req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> => {
  const endpoint = inject(ENDPOINT_DOMAIN);

  return next(req).pipe(
    catchError((reason: HttpErrorResponse) => {
      return throwError(() => {
        if (endpoint && req.url && !req.url.startsWith(endpoint)) {
          return reason;
        }

        if (reason.status === 401) {
          // redirect, logout або інша логіка
        }

        return new HttpApiError(reason);
      });
    })
  );
};
